document.addEventListener('DOMContentLoaded', () => {
  const cartItemsEl = document.querySelector('cart-items');
  const mainCartItems = document.getElementById('main-cart-items');
  if (!cartItemsEl || !mainCartItems) return;

  // Patch updateQuantity on the cart-items instance so that every removal or
  // quantity change (from the remove button OR the quantity input) goes through
  // our gift-aware logic before falling back to the original method.
  const _originalUpdateQuantity = cartItemsEl.updateQuantity.bind(cartItemsEl);

  cartItemsEl.updateQuantity = async function(line, quantity, name) {
    const lineIndex = Number(line);
    const newQuantity = Number(quantity);

    try {
      const cart = await fetch('/cart.js').then((res) => res.json());
      const kitItem = cart.items[lineIndex - 1];

      if (!kitItem) {
        _originalUpdateQuantity(line, quantity, name);
        return;
      }

      const giftItem = cart.items.find(
        (item) =>
          String(item.properties['_gift_for_kit']) === String(kitItem.variant_id)
      );

      if (!giftItem) {
        _originalUpdateQuantity(line, quantity, name);
        return;
      }

      // Linked gift found — handle both items together
      const giftLineIndex = cart.items.indexOf(giftItem) + 1;

      showCartGlobalLoader();

      if (newQuantity === 0) {
        // Remove both — higher index first to avoid line-index shifting
        const [higherIndex, lowerIndex] =
          lineIndex > giftLineIndex
            ? [lineIndex, giftLineIndex]
            : [giftLineIndex, lineIndex];

        await fetch(routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: higherIndex, quantity: 0 }),
        });

        const sections = cartItemsEl.getSectionsToRender().map((s) => s.section);

        const response = await fetch(routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: lowerIndex,
            quantity: 0,
            sections,
            sections_url: window.location.pathname,
          }),
        }).then((res) => res.json());

        cartItemsEl.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id)?.querySelector(section.selector) ||
            document.getElementById(section.id);
          if (elementToReplace && response.sections?.[section.section]) {
            elementToReplace.innerHTML = cartItemsEl.getSectionInnerHTML(
              response.sections[section.section],
              section.selector
            );
          }
        });

        cartItemsEl.classList.toggle('is-empty', response.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');
        if (cartFooter) cartFooter.classList.toggle('is-empty', response.item_count === 0);

        animateCartDrawerProgressBar();
        hideCartGlobalLoader();
      } else {
        // Quantity change — update kit first, then sync gift to same quantity
        await fetch(routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: lineIndex, quantity: newQuantity }),
        });

        const sections = cartItemsEl.getSectionsToRender().map((s) => s.section);

        const response = await fetch(routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: giftLineIndex,
            quantity: newQuantity,
            sections,
            sections_url: window.location.pathname,
          }),
        }).then((res) => res.json());

        cartItemsEl.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id)?.querySelector(section.selector) ||
            document.getElementById(section.id);
          if (elementToReplace && response.sections?.[section.section]) {
            elementToReplace.innerHTML = cartItemsEl.getSectionInnerHTML(
              response.sections[section.section],
              section.selector
            );
          }
        });

        cartItemsEl.classList.toggle('is-empty', response.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');
        if (cartFooter) cartFooter.classList.toggle('is-empty', response.item_count === 0);

        animateCartDrawerProgressBar();
        hideCartGlobalLoader();
      }
    } catch (e) {
      console.error(e);
      hideCartGlobalLoader();
    }
  };
});

document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  cartDrawer.addEventListener(
    'click',
    async (event) => {
      const removeButton = event.target.closest('cart-remove-button');
      if (!removeButton) return;

      // Intercept ALL cart-remove-button clicks so we can check for a linked gift
      event.stopPropagation();

      const lineIndex = Number(removeButton.dataset.index);
      const cartItems =
        removeButton.closest('cart-drawer-items') ||
        removeButton.closest('cart-items');

      try {
        const cart = await fetch('/cart.js').then((res) => res.json());
        const kitItem = cart.items[lineIndex - 1];

        if (!kitItem) {
          cartItems?.updateQuantity(String(lineIndex), 0);
          return;
        }

        const giftItem = cart.items.find(
          (item) =>
            String(item.properties['_gift_for_kit']) ===
            String(kitItem.variant_id)
        );

        if (!giftItem) {
          // No linked gift — proceed with normal single-item removal
          cartItems?.updateQuantity(String(lineIndex), 0);
          return;
        }

        const giftLineIndex = cart.items.indexOf(giftItem) + 1;

        showCartGlobalLoader();

        // Remove higher-index item first to prevent line-index shifting
        const [higherIndex, lowerIndex] =
          lineIndex > giftLineIndex
            ? [lineIndex, giftLineIndex]
            : [giftLineIndex, lineIndex];

        await fetch(routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: higherIndex, quantity: 0 }),
        });

        const response = await fetch(routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: lowerIndex,
            quantity: 0,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        }).then((res) => res.json());

        // Update cart drawer sections from server-rendered HTML
        const parser = new DOMParser();

        if (response.sections?.['cart-drawer']) {
          const cartDrawerEl = document.querySelector('#CartDrawer');
          if (cartDrawerEl) {
            cartDrawerEl.innerHTML = parser
              .parseFromString(response.sections['cart-drawer'], 'text/html')
              .querySelector('#CartDrawer').innerHTML;
          }
        }

        if (response.sections?.['cart-icon-bubble']) {
          const cartIconBubble = document.getElementById('cart-icon-bubble');
          if (cartIconBubble) {
            cartIconBubble.innerHTML = parser
              .parseFromString(
                response.sections['cart-icon-bubble'],
                'text/html'
              )
              .querySelector('.shopify-section').innerHTML;
          }
        }

        if (response.item_count === 0) {
          cartDrawer.classList.add('is-empty');
        }

        animateCartDrawerProgressBar();
        hideCartGlobalLoader();
      } catch (e) {
        console.error(e);
        hideCartGlobalLoader();
      }
    },
    true // capture phase — fires before CartRemoveButton's bubble listener
  );

  // Intercept quantity changes for kit items that have a linked gift product.
  // Fires in capture phase so we can stop propagation before CartItems.onChange runs.
  cartDrawer.addEventListener(
    'change',
    async (event) => {
      // Only handle quantity input changes
      if (!event.target.closest('quantity-input')) return;

      const input = event.target;
      const lineIndex = Number(input.dataset.index);
      const newQuantity = Number(input.value);

      if (!lineIndex) return;

      // Stop propagation immediately — prevents CartItems.onChange debounced handler from firing
      event.stopPropagation();

      const cartItems =
        input.closest('cart-drawer-items') || input.closest('cart-items');

      try {
        const cart = await fetch('/cart.js').then((res) => res.json());
        const kitItem = cart.items[lineIndex - 1];

        if (!kitItem) {
          cartItems?.updateQuantity(String(lineIndex), String(newQuantity));
          return;
        }

        const giftItem = cart.items.find(
          (item) =>
            String(item.properties['_gift_for_kit']) === String(kitItem.variant_id)
        );

        if (!giftItem) {
          // No linked gift — delegate to native handler which manages its own loader + DOM update
          cartItems?.updateQuantity(String(lineIndex), String(newQuantity));
          return;
        }

        const giftLineIndex = cart.items.indexOf(giftItem) + 1;

        showCartGlobalLoader();

        // Update kit item quantity first (no sections — intermediate call)
        await fetch(routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: lineIndex, quantity: newQuantity }),
        });

        // Update gift item quantity and request updated section HTML
        const response = await fetch(routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: giftLineIndex,
            quantity: newQuantity,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        }).then((res) => res.json());

        const parser = new DOMParser();

        if (response.sections?.['cart-drawer']) {
          const cartDrawerEl = document.querySelector('#CartDrawer');
          if (cartDrawerEl) {
            cartDrawerEl.innerHTML = parser
              .parseFromString(response.sections['cart-drawer'], 'text/html')
              .querySelector('#CartDrawer').innerHTML;
          }
        }

        if (response.sections?.['cart-icon-bubble']) {
          const cartIconBubble = document.getElementById('cart-icon-bubble');
          if (cartIconBubble) {
            cartIconBubble.innerHTML = parser
              .parseFromString(response.sections['cart-icon-bubble'], 'text/html')
              .querySelector('.shopify-section').innerHTML;
          }
        }

        if (response.item_count === 0) {
          cartDrawer.classList.add('is-empty');
        }

        animateCartDrawerProgressBar();
        hideCartGlobalLoader();
      } catch (e) {
        console.error(e);
        hideCartGlobalLoader();
      }
    },
    true // capture phase — fires before CartItems.onChange debounced handler
  );
});
